import { render, staticRenderFns } from "./UserTaskDetail.vue?vue&type=template&id=56533661&"
import script from "./UserTaskDetail.vue?vue&type=script&lang=js&"
export * from "./UserTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56533661')) {
      api.createRecord('56533661', component.options)
    } else {
      api.reload('56533661', component.options)
    }
    module.hot.accept("./UserTaskDetail.vue?vue&type=template&id=56533661&", function () {
      api.rerender('56533661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/UserTaskDetail.vue"
export default component.exports